exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".StartpointWrapper-module__startpoint-wrapper___7CS3M{width:100%;background-color:#f4f4f4;border-radius:15px;padding:20px;display:grid;grid-template-rows:190px;justify-content:center;justify-items:center}.StartpointWrapper-module__startpoint-wrapper___7CS3M .StartpointWrapper-module__ground-plane___2w5b_{grid-area:1/1/1/1;align-self:end}", ""]);

// exports
exports.locals = {
	"startpoint-wrapper": "StartpointWrapper-module__startpoint-wrapper___7CS3M",
	"ground-plane": "StartpointWrapper-module__ground-plane___2w5b_"
};